import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import { SyndicateInviteLinkStatusEnumType } from '__generated__/graphql';
import { FC } from 'react';

import { FormInput, FormPanelWithReadMode } from 'components/FormPanel';

import { Dialog, DialogPanel, DialogTitle } from 'primitives/Dialog';

const UPDATE_SYNDICATE_INVITE_LINK_STATUS = gql(`
  mutation UpdateSyndicateInviteLink($id: ID!, $status: SyndicateInviteLinkStatusEnumType!) {
    updateSyndicateInviteLinkStatus(id: $id, status: $status) {
      id
      status
    }
  }
`);

const UpdateSyndicateInviteLinkStatus: FC<{
  id: string;
  status: SyndicateInviteLinkStatusEnumType;
  onClose: () => void;
}> = ({ id, status, onClose }) => {
  const [updateSyndicateInviteLinkStatus, { loading, error }] = useMutation(
    UPDATE_SYNDICATE_INVITE_LINK_STATUS
  );

  return (
    <Dialog open={true} onClose={onClose}>
      <DialogPanel>
        <DialogTitle>Update Syndicate Invite Link Status</DialogTitle>
        <FormPanelWithReadMode
          loading={loading}
          error={error}
          onSubmit={data => {
            updateSyndicateInviteLinkStatus({
              variables: {
                id,
                status: data.status,
              },
            }).then(() => {
              onClose();
            });
          }}
        >
          <FormInput
            type="select"
            fieldName="status"
            label="Status"
            defaultValue={status}
            options={[
              { value: 'ACTIVE', label: 'Active', color: 'bg-green-500' },
              { value: 'INACTIVE', label: 'Inactive', color: 'bg-red-500' },
            ]}
          />
        </FormPanelWithReadMode>
      </DialogPanel>
    </Dialog>
  );
};

export default UpdateSyndicateInviteLinkStatus;
